import type { LivestreamSnapshot } from "./types";

export type LivestreamGameResult = {
  sourceGameId: string;
  score: "1-0" | "0-1" | "1/2-1/2";
  tone: "white" | "black" | "draw";
};

export function resolveLivestreamGameResult(snapshot: LivestreamSnapshot): LivestreamGameResult | null {
  const { game } = snapshot;
  if (!game) {
    return null;
  }
  if (game.result !== "1-0" && game.result !== "0-1" && game.result !== "1/2-1/2") {
    return null;
  }

  // Positions are exposed before the target move. The importer intentionally
  // omits the final ply as a guess target, so `ply_count - 2` is the last live
  // slot for a finished source game.
  if (game.ply_count < 2 || game.ply_index < game.ply_count - 2) {
    return null;
  }

  return {
    sourceGameId: game.source_game_id,
    score: game.result,
    tone: game.result === "1-0" ? "white" : game.result === "0-1" ? "black" : "draw",
  };
}
